export default __webpack_public_path__ + "static/media/tutorial2.57fca717.png";